import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import escolas from "../../api/escolas";
import { errorToString } from "../../helpers/funcoes";
import { Titulo } from "../Titulo";

export function EscolasForm() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string>();

  const [nome, setNome] = useState("");
  const [anos, setAnos] = useState<number[]>([]);

  useEffect(() => {
    if (id) {
      setLoading(true);
      escolas
        .read(id)
        .then((res) => {
          setNome(res.nome);
          setAnos(res.anos);
        })
        .catch((err) => setError(errorToString(err)))
        .finally(() => setLoading(false));
    }
  }, []);

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setSaving(true);
    setError(undefined);

    const payload = {
      nome,
      anos,
    };

    (id ? escolas.update(id, payload) : escolas.create(payload))
      .then(() => navigate("/escolas"))
      .catch((err) => setError(errorToString(err)));
  };

  const onAnoChange = (ano: number, checked: boolean) => {
    if (checked) {
      setAnos([ano, ...anos]);
    } else {
      const n = [...anos];
      const i = n.indexOf(ano);
      if (i >= 0) {
        n.splice(i, 1);
        setAnos(n);
      }
    }
  };

  if (loading) {
    return (
      <div className="text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Form onSubmit={onSubmit}>
      <Titulo text={`${id ? "Editar" : "Adicionar"} Escola`} />
      {error && (
        <Alert color="danger" data-cy="alert">
          {error}
        </Alert>
      )}
      <FormGroup row>
        <Label for="txtNome" sm={2}>
          Nome:
        </Label>
        <Col sm={10}>
          <Input
            id="txtNome"
            data-cy="nome"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
            disabled={saving}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label sm={2}>Anos:</Label>
        <Col sm={10}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
            <FormGroup key={i} check inline>
              <Input
                id={`chkAno${i}`}
                type="checkbox"
                checked={anos.includes(i)}
                onChange={(e) => onAnoChange(i, e.target.checked)}
              />
              <Label for={`chkAno${i}`} check>
                {i}º
              </Label>
            </FormGroup>
          ))}
        </Col>
      </FormGroup>
      <Row>
        <Col sm={6}>{saving && <Spinner />}</Col>
        <Col sm={6} className="text-end">
          <Button type="submit" disabled={saving}>
            Salvar
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
